<template>
    <div class="flex flex-col h-full items-center justify-center overflow-auto">
        <div class="items-center">
            <div class="flex flex-col w-full" :class="phoneScreen.landscape && 'space-y-2 lg:space-y-4 2xl:space-y-8 sm:h-96 lg:h-auto sm:mt-40 lg:mt-0 pb-10'   || 'space-y-4'">

                <div class="flex flex-col space-y-1 text-black">
                    <div class="flex space-x-2  items-center justify-center">
                        <div class="border-4  p-2 rounded-xl cursor-pointer games-islem-tahmin-border-color" v-for="o, key in operations" :key="key"
                            :class="o.visible ? 'games-islem-tahmin-bg' : 'bg-white'"
                            @click="o.visible = !o.visible"
                        >
                            <img :src="o.icon" class="w-12" :class="phoneScreen.landscape ? 'sm:w-8 lg:w-12' : 'lg:w-12'" alt="">
                        </div>
                    </div>
                </div>

                <div class="flex">
                    <div class="w-full bg-white border-2 flex p-2 items-center rounded-xl games-islem-tahmin-border-color">
                        <div class="w-full px-2">{{ newTime == 0 ? $t('islem_tahmin_title_no_time') : `${ newTime } ${$t('islem_tahmin_title_second')}`}}</div>
                        <div class="flex space-x-2">
                            <a class="games-islem-tahmin-bg px-4 py-2 rounded-xl cursor-pointer font-bold text-xl" @click="newTime > 0 && (newTime = newTime-30)">-</a>
                            <a class="games-islem-tahmin-bg px-4 py-2 rounded-xl cursor-pointer font-bold text-xl" @click="newTime = newTime+30">+</a>
                        </div>
                    </div>
                </div>

                <div class="flex space-x-2 w-full items-center justify-center">
                    <div class="flex items-center space-x-2 border-2 rounded-xl cursor-pointer games-islem-tahmin-border-color" v-for="i,key in hardArr" :key="key"
                    :class="key == hard ? 'games-islem-tahmin-bg' : 'bg-white'">
                        <div
                        class=" font-bold text-sm lg:text-base 2xl:text-lg p-2 rounded-xl"
                        @click="hard = key">
                            {{ i }}
                        </div>
                    </div>
                </div>

                <div class="flex space-x-2 w-full items-center justify-center">
                    <div class="flex items-center space-x-2 border-2  rounded-xl cursor-pointer games-islem-tahmin-border-color" v-for="i in 2" :key="i"
                    :class="playerCount == i ? 'games-islem-tahmin-bg' : 'bg-white'">
                        <div class="font-bold text-sm lg:text-base 2xl:text-lg p-2 rounded-xl" @click="playerCount = i">
                            {{ $t('islem_tahmin_description_gamer', {gamer: i}) }}
                        </div>
                    </div>
                </div>

                <div class="flex items-center justify-center">
                    <button class=" px-10  games-islem-tahmin-bg-light text-white p-3 rounded-xl cursor-pointer text-lg md:text-xl lg:text-2xl 2xl:text-4xl "
                    @click="start()">
                        {{ $t('islem_tahmin_button_start') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import {useScreen} from 'vue-screen'
import {ref, watch, onMounted} from 'vue'
import useSound from '../../sounds'
import i18next from 'i18next';
const phoneScreen = useScreen()
const emit = defineEmits(['screen', 'start', 'operations', 'hard', 'time'])
const props = defineProps(['hard', 'time'])
const {soundStart, soundSetVolume} = useSound({files_url:i18next.t('files_url')})


// const hardArr     = ['Kolay', 'Orta', 'Zor']
const hardArr     = [i18next.t('islem_tahmin_title_difficulty_easy'), i18next.t('islem_tahmin_title_difficulty_medium'), i18next.t('islem_tahmin_title_difficulty_hard')]



const hard        = ref(props.hard)
const newTime     = ref(props.time)
const playerCount = ref(1)

const operations = ref([
    {
        'title':'topla',
        'icon': i18next.t('files_url') + 'img/games/hedef_sayi_bulalim/topla.svg',
        'visible': true
    },
    {
        'title':'cikar',
        'icon': i18next.t('files_url') +  'img/games/hedef_sayi_bulalim/cikar.svg',
        'visible': true
    },
    {
        'title':'carp',
        'icon': i18next.t('files_url') +  'img/games/hedef_sayi_bulalim/carp.svg',
        'visible': true
    },
    {
        'title':'bol',
        'icon': i18next.t('files_url') +  'img/games/hedef_sayi_bulalim/bol.svg',
        'visible': true
    }
])

watch(playerCount, () => soundStart(2))

onMounted(() => {
    soundStart(2)
    emit('operations',operations.value)
})

watch(newTime, (cTime) => {
    soundStart(2)
    emit('time', cTime)
})

watch(hard, (cHard) => {
    soundStart(2)
    emit('hard', cHard)
})

watch(operations, (cOperations) => {
    emit('operations',cOperations)
    soundStart(2)
}, {deep: true})

const setScreen = (screen) => {
    emit('screen', screen)
}

const start = () => {
    soundStart(2)
    emit('start', playerCount.value)
}
</script>
